/* Takumi™ hibridinė keptuvė — shared behaviour.
   Every section renders this script; it guards itself so it installs once.
   State names and defaults are the source's own `state = { … }`. */
(function () {
  if (window.TK) return;
  var TK = window.TK = {};
  /* Printed by the console check below, so which build a theme is
     actually serving can be read off the page instead of guessed. */
  TK.version = '2026-10-05-set';

  /* ----------------------------------------------- leftover page anchors
     The rating line used to be a plain <a href="#atsiliepimai">, so clicking it
     wrote that anchor into the address bar — and from then on the browser
     jumped there on every single load, before any script could stop it. The
     markup no longer writes it, but a saved tab, a bookmark or a history entry
     still carries it. Drop it and open at the top; other anchors are left
     alone, so real deep links keep working. */
  (function dropOwnHash() {
    var own = ['#atsiliepimai', '#peiliai'];
    if (own.indexOf(window.location.hash) < 0) return;
    try {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    } catch (e) {}
    window.scrollTo(0, 0);
    /* The browser performs its own jump after the document finishes, so undo
       it once more there. */
    window.addEventListener('load', function () { window.scrollTo(0, 0); });
  })();

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* source: state = { variant:'28', bundle:2, shot:0, cart:0, menuOpen:false,
     faq:0, allReviews:false, expIdx:0, videoPlaying:true, layer:0, infoRow:-1,
     heroRev:0, pastFold:false, stripIdx:0, revIdx:0, expRow1:0, expRow2:3 } */
  var state = {
    variant: '28', bundle: 2, shot: 0, cart: 0,
    allReviews: false, expIdx: 0, layer: 0, heroRev: 0, pastFold: false
  };

  /* ------------------------------------------------------------ pricing
     source: fmt = n => n.toFixed(2).replace('.', ',') + ' €'
             price() = { now: b.base + v.delta, was: b.was + v.delta * 2 } */
  function fmt(n) { return n.toFixed(2).replace('.', ',') + ' €'; }

  function variants() {
    return $$('[data-tk-size]').map(function (el) {
      return { id: el.dataset.tkSize, label: el.dataset.label, delta: parseFloat(el.dataset.delta) };
    });
  }
  /* "20:5190|24:5990|" — the real variant prices in cents, per size, written
     by the section when the card points at a product. Empty when it does not,
     and then the typed-in numbers are used instead. */
  function priceMap(raw) {
    var out = {};
    (raw || '').split('|').forEach(function (part) {
      var c = part.indexOf(':');
      if (c < 0) return;
      var k = part.slice(0, c).trim(), v = parseFloat(part.slice(c + 1));
      if (k && !isNaN(v)) out[k] = v / 100;
    });
    return out;
  }

  function bundles() {
    return $$('[data-tk-bundle]').map(function (el) {
      return {
        id: el.dataset.tkBundle, el: el,
        base: parseFloat(el.dataset.base), was: parseFloat(el.dataset.was),
        live: priceMap(el.dataset.prices), liveWas: priceMap(el.dataset.compares)
      };
    });
  }

  /* What this card costs at the chosen size: the shop's own price when it is
     known, the typed number otherwise. */
  function discountPct(el) {
    var n = el ? parseFloat(el.dataset.discount) : 0;
    return isNaN(n) ? 0 : n;
  }

  /* "20 | 74,00 € | 98,67 €" — prices written out by hand, one line per size,
     shown exactly as typed. Nothing is calculated from them, so what is on the
     page is what was entered, and it outranks every other source. */
  function writtenPrices(raw) {
    var out = {};
    (raw || '').split(/\r?\n/).forEach(function (line) {
      var parts = line.split('|');
      if (parts.length < 2) return;
      var key = parts[0].trim();
      if (!key) return;
      out[key] = { now: parts[1].trim(), was: (parts[2] || '').trim() };
    });
    return out;
  }

  /* The saving is the only figure that has to be a number. Read whatever digits
     the two lines carry; if they cannot be read, the badge keeps its last
     value rather than printing nonsense. */
  function amount(text) {
    var m = (text || '').replace(/\s/g, '').match(/-?\d+(?:[.,]\d+)?/);
    return m ? parseFloat(m[0].replace(',', '.')) : NaN;
  }

  function priceOf(bb, v) {
    var d = sizePriced(bb.el) ? v.delta : 0;
    var hand = writtenPrices(bb.el.dataset.priceLines);
    var keys = Object.keys(hand);
    if (keys.length) {
      var row = hand[v.id] || (keys.length === 1 ? hand[keys[0]] : null);
      if (row) return { text: row, now: amount(row.now), was: amount(row.was) };
    }
    var now = bb.live[v.id];
    if (now === undefined && !sizePriced(bb.el)) {
      for (var k in bb.live) { now = bb.live[k]; break; }
    }
    if (now === undefined) return { now: bb.base + d, was: bb.was + d * 2 };
    /* A named discount is measured against the price being charged, so the
       crossed-out figure is derived from it rather than read from Shopify's
       compare-at. Nothing about what the cart takes changes. */
    var pct = discountPct(bb.el);
    if (pct > 0 && pct < 95) return { now: now, was: now * 100 / (100 - pct) };
    var was = bb.liveWas[v.id];
    if (was === undefined && !sizePriced(bb.el)) {
      for (var k2 in bb.liveWas) { was = bb.liveWas[k2]; break; }
    }
    return { now: now, was: was === undefined || was <= now ? bb.was + d * 2 : was };
  }
  function selVariant() {
    var vs = variants();
    for (var i = 0; i < vs.length; i++) if (vs[i].id === state.variant) return vs[i];
    return vs[0] || { label: '', delta: 0 };
  }
  function selBundle() {
    var bs = bundles();
    for (var i = 0; i < bs.length; i++) if (bs[i].id === String(state.bundle)) return bs[i];
    return bs[0];
  }

  /* The editor's product picker route: the chosen bundle carries its product's
     variants as "title=id|" pairs, and the chosen size names which title it
     stands for. One variant means the size does not have to name anything. */
  function variantFromProduct() {
    var bundle = $('[data-tk-bundle][aria-checked="true"]');
    /* A diameter may name its variant outright. That is the plainest wiring
       there is — no product picker, no variant title to keep in step with
       Shopify — so it is read before anything else, and only for the card the
       diameter actually applies to. */
    if (sizeDriven(bundle)) {
      var pill = $('[data-tk-size][aria-checked="true"]');
      var own = pill ? (pill.getAttribute('data-variant-id') || '').trim() : '';
      if (own) return own;
    }
    var raw = bundle ? bundle.getAttribute('data-variants') || '' : '';
    if (!raw) return '';
    var pairs = {}, order = [];
    raw.split('|').forEach(function (part) {
      var eq = part.indexOf('=');
      if (eq < 0) return;
      var t = part.slice(0, eq).trim(), v = part.slice(eq + 1).trim();
      if (t && v) { pairs[t] = v; order.push(v); }
    });
    if (!order.length) return '';
    /* Only the card that is priced by diameter is also chosen by diameter. The
       set cards hold a fixed combination — asking them for a "20 cm" variant
       would find nothing and leave the button unwired, which is how adding a
       set stopped working. They take their product's own variant instead. */
    if (!sizeDriven(bundle)) return order[0];
    var size = $('[data-tk-size][aria-checked="true"]');
    var want = size ? (size.getAttribute('data-variant-title') || '').trim() : '';
    if (!want) return order.length === 1 ? order[0] : '';
    if (pairs[want]) return pairs[want];
    /* The field may hold the id or the admin link ending in it, not the title. */
    var tail = want.split('/').pop().trim();
    for (var i = 0; i < order.length; i++) {
      if (order[i] === want || order[i] === tail) return order[i];
    }
    /* A set has one variant — Shopify calls it "Default Title" — so there is
       nothing for a diameter to name and nothing that could be picked wrongly.
       Use it. Without this the card stayed unwired and the button answered
       "Trukstama eilute: = varianto ID", asking for an id that does not exist. */
    if (order.length === 1) return order[0];
    /* Named something this product does not have, and the product has several
       variants: refuse rather than fall back to another one, which is how the
       wrong item reached the cart. */
    return '';
  }

  /* "28|2 = 45123456789012" per line, parsed once. Kept as text rather than a
     picker because the id depends on BOTH the size and the bundle, which are
     separate blocks - nine combinations with three of each. */
  var _variants = null;
  function variantFor(key) {
    if (_variants === null) {
      _variants = {};
      var host = $('[data-tk-variant-map]');
      var raw = host ? host.getAttribute('data-tk-variant-map') || '' : '';
      raw.split(/[\r\n]+/).forEach(function (line) {
        var eq = line.indexOf('=');
        if (eq < 0) return;
        var k = line.slice(0, eq).trim(), v = line.slice(eq + 1).trim();
        if (k && v) _variants[k] = v;
      });
    }
    return _variants[key] || '';
  }

  /* Only the bare-pan card is priced by diameter. The set cards are fixed
     combinations — 28 + 24, 28 + 24 + 20 — so the pills must leave their price
     alone, and each card says for itself which it is. */
  /* The price follows the diameter on the same card the diameter belongs to.
     Three separate opt-in switches meant a card could show "24 cm" under its
     title while quoting the 28 cm price, which is worse than either — so one
     answer now drives the subtitle, the photo, the price and the variant. */
  function sizePriced(el) {
    return sizeDriven(el);
  }

  /* Which card the diameter belongs to. Any of the three "follows the selected
     size" switches says the same thing about a card, so any one of them is
     enough — a card whose subtitle already shows the diameter is plainly the
     one the diameter is for, and having to tick a second box named after the
     price to get the right variant into the cart was a trap. */
  function sizeDriven(el) {
    if (!el) return false;
    if (el.dataset.sizeDriven !== undefined) return el.dataset.sizeDriven === 'true';
    /* An older section file in the theme carries no such mark. Rather than
       treat every card as fixed — which freezes the price and makes the size
       pills look dead — fall back to how it behaved before: the diameter
       applies to all of them. */
    return true;
  }

  /* ------------------------------------------------------ self check
     A phone has no console worth using, so the page can show its own state on
     demand: add ?tkdebug=1 to the address and a small panel appears with the
     build it is running and what it currently thinks is selected. It is enough
     to photograph, which is the fastest way to tell a stale file from a real
     fault. Nothing is shown without that flag. */
  function debugOn() {
    return /[?&]tkdebug=1/.test(window.location.search);
  }

  function debugPanel() {
    if (!debugOn()) return null;
    var el = $('#tk-debug');
    if (el) return el;
    el = document.createElement('pre');
    el.id = 'tk-debug';
    el.style.cssText = 'position:fixed; left:8px; right:8px; bottom:8px; z-index:99999;' +
      'margin:0; padding:10px 12px; background:rgba(8,8,10,0.94); color:#d8f5c8;' +
      'font:11px/1.45 ui-monospace, monospace; border:1px solid #3a7d2c; border-radius:10px;' +
      'white-space:pre-wrap; max-height:46vh; overflow:auto';
    document.body.appendChild(el);
    el.addEventListener('click', function () { el.remove(); });
    return el;
  }

  function debugDump() {
    var el = debugPanel();
    if (!el) return;
    var b = selBundle(), v = selVariant();
    var add = $('[data-tk-add]:not([data-own-variant])');
    var own = $('[data-tk-add][data-own-variant]');
    var lines = [
      'runtime      ' + TK.version,
      'sekcija      ' + ($('[data-tk-bundle]') && $('[data-tk-bundle]').dataset.sizeDriven !== undefined
                         ? 'nauja (data-size-driven yra)' : 'SENA (data-size-driven nera)'),
      'dydis        ' + (v ? v.label + '  id=' + v.id + '  delta=' + v.delta : '-'),
      'kortele      ' + (b ? (b.el.dataset.title || '?') + '  id=' + b.id : '-'),
      '  seka dydi  ' + (b ? sizeDriven(b.el) : '-'),
      '  rankinės   ' + (b ? (b.el.dataset.priceLines || '(nera)').replace(/\n/g, ' // ') : '-'),
      '  shopify    ' + (b ? (b.el.dataset.prices || '(nera)') : '-'),
      '  nuolaida   ' + (b ? (b.el.dataset.discount || '0') + '%' : '-'),
      'rodoma       ' + ($('[data-tk-total]') || {}).textContent + '   buvo ' +
                        ($('[data-tk-total-was]') || {}).textContent,
      'i krepseli   ' + (add ? (add.dataset.variantId || '(tuscia)') : '-'),
      'rinkinio mygt ' + (own ? (own.dataset.variantId || '(tuscia)') : '(nera)')
    ];
    el.textContent = lines.join('\n');
  }

  /* ---------------------------------------------- whole-pixel card edges
     The selected card draws a 2px ring. When its own height works out to a
     half pixel — 101.5 — that ring cannot be split evenly across the device
     pixels, and the bottom edge is painted one row thinner than the top. The
     stylesheet cannot round a height, so it is rounded here, once the text has
     settled. Measured at dpr 2 and dpr 3: 4/3 before, 4/4 after.
     Heights are cleared before measuring so a later pass cannot pile up on an
     earlier one. */
  function evenCardEdges() {
    var cards = $$('[data-tk-bundle]');
    if (!cards.length) return;
    cards.forEach(function (c) { c.style.height = ''; });
    var hs = cards.map(function (c) { return c.getBoundingClientRect().height; });
    cards.forEach(function (c, i) {
      if (hs[i] > 0) c.style.height = Math.ceil(hs[i]) + 'px';
    });
  }

  function renderPrice() {
    var v = selVariant(), b = selBundle();
    if (!b) return;
    var head = priceOf(b, v);
    var now = head.now, was = head.was;

    /* "Skersmuo: 28 cm" — the markup carried this hook from the start, but
       nothing ever wrote to it, so the line kept the size the page was built
       with however many pills were pressed. */
    $$('[data-tk-size-label]').forEach(function (e) { e.textContent = v.label; });


    $$('[data-tk-total]').forEach(function (e) {
      e.textContent = head.text ? head.text.now : fmt(now);
    });
    $$('[data-tk-total-was]').forEach(function (e) {
      e.textContent = head.text ? head.text.was : fmt(was);
    });
    $$('[data-tk-saving]').forEach(function (e) {
      if (isNaN(now) || isNaN(was) || was <= now) { e.hidden = true; return; }
      e.hidden = false;
      e.textContent = 'Sutaupote ' + fmt(was - now);
    });

    /* every bundle card shows its own price, at the selected size where
       that card is the one the size applies to */
    bundles().forEach(function (bb) {
      var p = $('[data-tk-bundle-price]', bb.el), w = $('[data-tk-bundle-was]', bb.el);
      var pr = priceOf(bb, v);
      if (p) p.textContent = pr.text ? pr.text.now : fmt(pr.now);
      if (w) w.textContent = pr.text ? pr.text.was : fmt(pr.was);
      /* source: sub = b.id === 1 ? selV.label : b.sub */
      var sub = $('[data-tk-bundle-sub-size]', bb.el);
      if (sub) sub.textContent = v.label;
      /* The bare-pan card is a different photo per diameter; the set cards keep
         their own. Falls back to the card's own picture when that size has none. */
      var bimg = $('[data-tk-bundle-img-size]', bb.el);
      if (bimg) {
        var pill = $('[data-tk-size][aria-checked="true"]');
        var url = (pill && pill.dataset.hero ? pill.dataset.hero.trim() : '') || bimg.dataset.fallback || '';
        if (url && bimg.getAttribute('src') !== url) bimg.setAttribute('src', url);
        bimg.hidden = !url;
      }
    });

    /* stickyLabel = 'Takumi™ ' + selV.label + ' · ' + bundle.title */
    var title = b.el.dataset.title || '';
    $$('[data-tk-sticky-label]').forEach(function (e) {
      /* Only the card the diameter applies to is worth naming it on. A set
         holds fixed sizes, so "28 cm · 2 Dalių Rinkinys" says something untrue
         about two of the three pans in it. */
      e.textContent = sizePriced(b.el)
        ? 'Takumi™ ' + v.label + ' · ' + title
        : title;
    });
    $$('[data-tk-sticky-price]').forEach(function (e) { e.textContent = fmt(now); });

    /* The bar carries the chosen bundle's own picture, so what it offers is
       recognisable without scrolling back up. Falls back to the first gallery
       slide for a card with no picture of its own. */
    $$('[data-tk-sticky-thumb]').forEach(function (img) {
      var src = '';
      var inCard = b.el.querySelector('img');
      if (inCard) src = inCard.getAttribute('src') || '';
      if (!src) {
        var slide = $('[data-tk-shot-slide] img');
        if (slide) src = slide.getAttribute('src') || '';
      }
      if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      var box = img.parentElement;
      if (box) box.hidden = !src;
    });

    /* The variant the cart needs comes from the size + bundle matrix. The
       section's own Shopify variant IDs setting is read first; TK.variantMap
       stays supported for a store already wired that way by a custom script. */
    var key = state.variant + '|' + state.bundle;
    debugDump();

    $$('[data-tk-add]').forEach(function (btn) {
      /* A button that brought its own variant sells something else entirely —
         the 12-piece set has its own product picker. Overwriting it here put
         the page's own pan into the cart whenever a price was redrawn, which
         is every time a size or a bundle is touched. */
      if (btn.hasAttribute('data-own-variant')) return;
      btn.dataset.variantId = variantFromProduct() || variantFor(key) ||
                              (TK.variantMap && TK.variantMap[key]) || '';
      btn.dataset.variantKey = key;
    });
  }

  /* The diameter's own photo, shown over the gallery while that size is
     chosen. Nothing happens for a size left without one. */
  function showSizeHero(btn) {
    var pic = $('.tk-hero-size');
    if (!pic) return;
    var url = btn && btn.dataset.hero ? btn.dataset.hero.trim() : '';
    if (url) {
      if (pic.getAttribute('src') !== url) pic.setAttribute('src', url);
      pic.classList.add('is-on');
    } else {
      pic.classList.remove('is-on');
    }
  }

  function selectSize(id) {
    state.variant = id;
    $$('[data-tk-size]').forEach(function (el) {
      var on = el.dataset.tkSize === id;
      el.setAttribute('aria-checked', on ? 'true' : 'false');
      el.style.background = on ? '#26262b' : 'transparent';
      el.style.setProperty('--tk-pill-w', on ? '2px' : '1px');
      el.style.setProperty('--tk-pill-c', on ? '#efece6' : 'rgba(255,255,255,0.4)');
      if (on) showSizeHero(el);
    });
    renderPrice();
  }

  function selectBundle(id) {
    state.bundle = id;
    $$('[data-tk-bundle]').forEach(function (el) {
      var on = el.dataset.tkBundle === String(id);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
      el.style.background = on ? '#212125' : '#111113';
      /* An outline, not a border: a 1px border on a card whose height lands on
         a half device pixel is painted at partial opacity along one edge, and
         the bottom card read as having a thinner line than the rest. An outline
         is painted over the box in its own pass and keeps its full width. */
      /* The ring lives on the card's own ::after layer, above the photo. */
      el.style.setProperty('--tk-ring-w', on ? '2px' : '1px');
      el.style.setProperty('--tk-ring-c', on ? '#efece6' : 'rgba(255,255,255,0.11)');
    });
    renderPrice();
  }

  /* ------------------------------------------------------------ gallery */
  function selectShot(i, silent) {
    /* Touching the gallery — arrow, thumbnail or swipe — means the visitor
       wants the gallery, so the size's photo steps aside. Not on the silent
       first pass, or it would be dismissed before it is seen. */
    if (!silent) {
      var sp = $('.tk-hero-size');
      if (sp) sp.classList.remove('is-on');
    }
    var slides = $$('[data-tk-shot-slide]');
    var thumbs = $$('[data-tk-shot]');
    var n = slides.length || thumbs.length;
    if (!n) return;
    /* No wrap-around: the last photo is the last one. An arrow that jumps back
       to the start makes the strip feel endless and hides where you are. */
    state.shot = i < 0 ? 0 : (i > n - 1 ? n - 1 : i);
    var track = $('[data-tk-shot-track]');
    if (track) track.style.transform = 'translateX(' + (state.shot * -100) + '%)';
    slides.forEach(function (el, j) {
      el.setAttribute('aria-hidden', j === state.shot ? 'false' : 'true');
    });
    thumbs.forEach(function (el, j) {
      el.setAttribute('aria-current', j === state.shot ? 'true' : 'false');
    });
    /* The arrows stop at the ends rather than wrapping, and say so. */
    $$('[data-tk-shot-nav]').forEach(function (btn) {
      var last = Number(btn.dataset.dir) > 0 ? state.shot >= n - 1 : state.shot <= 0;
      btn.disabled = last;
      btn.style.opacity = last ? '0.35' : '';
      btn.style.cursor = last ? 'default' : '';
    });
    /* Keep the chosen thumbnail in view once the strip is long enough to
       scroll — but not on the first pass: at load the gallery may be off
       screen, and scrollIntoView would drag the page to it before the visitor
       has done anything. */
    var cur = thumbs[state.shot];
    if (!silent && cur && cur.scrollIntoView) {
      cur.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
  }

  /* A swipe across the main shot moves the gallery, the same as the arrows and
     the thumbnails. The thumbnail strip is a real scroller and is left alone. */
  function bindGallerySwipe() {
    var hero = $('.tk-hero');
    if (!hero) return;
    bindSwipe(hero, function (dir) {
      selectShot(state.shot + dir);
    });
  }

  /* --------------------------------------------------------- accordions
     One open per group; clicking the open one closes it (source: -1). */
  /* Flag a panel while its grid track is actually interpolating, so the
     browser can promote just that one, and drop the hint when it settles. */
  function animatePanel(panel) {
    if (!panel) return;
    panel.classList.add('is-animating');
    var done = function () {
      panel.classList.remove('is-animating');
      panel.removeEventListener('transitionend', done);
    };
    panel.addEventListener('transitionend', done);
    setTimeout(done, 500);
  }

  function toggleAcc(btn) {
    var group = btn.closest('[data-tk-acc-group]');
    var open = btn.getAttribute('aria-expanded') === 'true';
    if (group) {
      $$('[data-tk-acc]', group).forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) { animatePanel(p); p.setAttribute('data-open', 'false'); }
      });
    }
    if (!open) {
      btn.setAttribute('aria-expanded', 'true');
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) { animatePanel(panel); panel.setAttribute('data-open', 'true'); }
    }
  }

  /* ----------------------------------------------------------- carousels
     source nearestIdx(): the card whose centre is nearest the scroller centre.
     A programmatic smooth scroll fires `scroll` on every intermediate frame, so
     the index is locked to the target for the duration of the animation —
     otherwise a second click counts from a stale position. */
  function nearestIdx(el) {
    var mid = el.scrollLeft + el.clientWidth / 2, best = 0, bestDist = Infinity;
    Array.prototype.forEach.call(el.children, function (c, i) {
      var center = c.offsetLeft - el.offsetLeft + c.offsetWidth / 2;
      var d = Math.abs(center - mid);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    return best;
  }

  /* An absolute target, not a relative nudge. `scrollBy` measures from where the
     strip is painted right now, but the browser applies it from where the smooth
     scroll already in flight is heading, so two quick clicks added up and the row
     shot past its last card into bare padding. A clamped `scrollTo` cannot
     compound and cannot leave the ends. */
  function goCard(el, i) {
    if (!el || !el.children[i]) return;
    var c = el.children[i];
    var left = el.scrollLeft
             + c.getBoundingClientRect().left - el.getBoundingClientRect().left
             - (el.clientWidth - c.offsetWidth) / 2;
    var max = el.scrollWidth - el.clientWidth;
    el.scrollTo({ left: Math.max(0, Math.min(left, max)), behavior: 'smooth' });
  }

  function bindCarousel(name, gap, onIndex) {
    var strip = $('[data-tk-strip="' + name + '"]');
    if (!strip) return;
    var lock = null, lockTimer = 0;

    function idx() { return lock != null ? lock : nearestIdx(strip); }
    function sync(i) {
      $$('[data-tk-dot="' + name + '"]').forEach(function (d, j) {
        d.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
      if (onIndex) onIndex(i, strip);
    }
    function lockTo(i) {
      lock = i;
      clearTimeout(lockTimer);
      lockTimer = setTimeout(function () { lock = null; }, 600);
      sync(i);
    }

    strip.addEventListener('scroll', function () {
      if (lock != null) return;
      sync(nearestIdx(strip));
    }, { passive: true });

    $$('[data-tk-nav="' + name + '"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = Number(btn.dataset.dir);
        var n = strip.children.length;
        /* The index was clamped here but the scroll was not: at the last
           card another click still slid the strip one card further, into the
           bare padding past the end, and holding the arrow down ran the whole
           row off the screen. Scrolling to the clamped card cannot overshoot:
           at either end the target is the card already shown, so nothing
           moves. */
        var target = Math.max(0, Math.min(idx() + dir, n - 1));
        lockTo(target);
        goCard(strip, target);
      });
    });

    $$('[data-tk-dot="' + name + '"]').forEach(function (dot, i) {
      dot.addEventListener('click', function () { lockTo(i); goCard(strip, i); });
    });

    sync(0);
  }

  /* ------------------------------------------------- Patirtis hover-expand
     Two rows of two on desktop. No mouseleave reset — the last hovered card in
     each row stays expanded (source: expHover0..3 only ever set). */
  function bindExperience() {
    $$('[data-tk-exp]').forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        var row = card.dataset.row;
        $$('[data-tk-exp][data-row="' + row + '"]').forEach(function (c) {
          c.setAttribute('data-expanded', c === card ? 'true' : 'false');
        });
      });
    });
    bindCarousel('exp', 20, function (i) {
      state.expIdx = i;
      $$('[data-tk-exp]').forEach(function (c, j) {
        c.setAttribute('data-active', j === i ? 'true' : 'false');
      });
    });
  }

  /* ------------------------------------------------- chef quote carousel */
  /* ------------------------------------------------------- swipe gestures
     One gesture reader for every sideways-swipable strip.

     The axis is decided once, from the first 8px of movement, and then held for
     the rest of the touch. A sideways gesture calls preventDefault so the page
     stops moving with it — without that the finger swiped the carousel and
     nudged the page up or down at the same time. A gesture judged vertical is
     never interfered with, so normal scrolling through the section is
     untouched. touchmove has to be non-passive for preventDefault to work, so
     it is bound to the strip alone, never the document. */
  function bindSwipe(host, onSwipe) {
    if (!host) return;
    var sx = 0, sy = 0, axis = 0, live = false;
    host.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { live = false; return; }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; axis = 0; live = true;
    }, { passive: true });
    host.addEventListener('touchmove', function (e) {
      if (!live || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
      if (!axis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 1 : -1;
      }
      if (axis === 1 && e.cancelable) e.preventDefault();
    }, { passive: false });
    host.addEventListener('touchend', function (e) {
      if (!live) return;
      live = false;
      if (axis !== 1) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) < 45) return;
      onSwipe(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  function bindHeroRev() {
    var quotes = $$('[data-tk-hr]');
    if (!quotes.length) return;
    var track = $('[data-tk-hr-track]');

    /* The track carries every quote and is moved as one piece. Nothing is
       hidden any more, so aria-hidden marks the off-screen ones for a screen
       reader instead. */
    function paint(i) {
      /* Stops at both ends rather than looping round. */
      var last = quotes.length - 1;
      state.heroRev = i < 0 ? 0 : (i > last ? last : i);
      if (track) track.style.transform = 'translateX(' + (state.heroRev * -100) + '%)';
      quotes.forEach(function (q, k) {
        q.setAttribute('aria-hidden', k === state.heroRev ? 'false' : 'true');
      });
      $$('[data-tk-hr-dot]').forEach(function (d, k) {
        d.setAttribute('aria-current', k === state.heroRev ? 'true' : 'false');
      });
      $$('[data-tk-hr-nav]').forEach(function (btn) {
        var off = Number(btn.dataset.dir) > 0 ? state.heroRev >= last : state.heroRev <= 0;
        btn.disabled = off;
        btn.style.opacity = off ? '0.35' : '';
        btn.style.cursor = off ? 'default' : '';
      });
    }
    function show(i) { paint(i); }

    $$('[data-tk-hr-nav]').forEach(function (b) {
      b.addEventListener('click', function () { show(state.heroRev + Number(b.dataset.dir)); });
    });
    $$('[data-tk-hr-dot]').forEach(function (d, i) {
      d.addEventListener('click', function () { show(i); });
    });

    /* Swapping quotes with the hidden attribute leaves nothing for a finger to
       drag, so only the arrows worked on a phone. */
    bindSwipe(track ? track.parentElement : quotes[0].parentElement, function (dir) {
      show(state.heroRev + dir);
    });

    paint(0);
  }

  /* ------------------------------------------------- sold in the last 24h
     One number per day, the same for everyone, picked from the date itself
     rather than stored — so no page cache can freeze it and no two visitors
     see different numbers. Rolls over at midnight Lithuanian time. */
  function dailySold() {
    var el = $('[data-tk-sold][data-daily]');
    if (!el) return;
    var lo = parseInt(el.dataset.min, 10), hi = parseInt(el.dataset.max, 10);
    if (!(lo > 0) || !(hi > 0)) return;
    if (hi < lo) { var t = lo; lo = hi; hi = t; }
    var day;
    try {
      day = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Vilnius', year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(new Date());
    } catch (e) { return; }
    /* FNV-1a over the date string: stable across browsers and sessions. */
    var h = 2166136261;
    for (var i = 0; i < day.length; i++) {
      h ^= day.charCodeAt(i);
      h = (h + (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24)) >>> 0;
    }
    el.textContent = String(lo + (h % (hi - lo + 1)));
  }

  /* ------------------------------------------------------ layer hotspots
     The layer buttons are rendered twice: once as hotspots on the exploded
     photo, once as the row of dots beside it. A single flat index across both
     rows made dot 4 the ninth button, and `hidden = j !== 9` then hid every one
     of the six copy blocks — the text simply vanished. Each row is numbered on
     its own instead. */
  function layerRows() {
    var rows = [];
    $$('[data-tk-layer]').forEach(function (m) {
      if (rows.indexOf(m.parentNode) < 0) rows.push(m.parentNode);
    });
    return rows;
  }
  function selectLayer(i) {
    state.layer = i;
    layerRows().forEach(function (row) {
    $$('[data-tk-layer]', row).forEach(function (m, j) {
      var on = j === i;
      m.setAttribute('aria-current', on ? 'true' : 'false');
      m.style.background = on ? '#b8342a' : 'rgba(11,11,12,0.82)';
      m.style.color = on ? '#ffffff' : '#e2ded7';
      m.style.border = '1px solid ' + (on ? '#b8342a' : 'rgba(199,74,63,0.65)');
      m.style.boxShadow = on ? '0 0 0 4px rgba(184,52,42,0.25)' : 'none';
    });
    });
    $$('[data-tk-layer-line]').forEach(function (l, j) {
      l.setAttribute('stroke', j === i ? '#b8342a' : 'rgba(239,236,230,0.38)');
    });
    $$('[data-tk-layer-copy]').forEach(function (c, j) { c.hidden = j !== i; });
  }

  /* ------------------------------------------------------------- video
     The design has no unmute control anywhere. Keep every video silent, and
     keep it silent — the source re-asserts it on an interval, so do the same. */
  /* Scoped to `.tk video` on purpose: an unscoped sweep would also silence a
     theme or app video sitting on the same page, every 250ms, with no way for
     the visitor to turn it back on. */
  function muteAll() {
    $$('.tk video').forEach(function (v) {
      if (!v.muted || v.volume > 0) { v.muted = true; v.volume = 0; }
    });
  }
  function bindVideo() {
    if (!$('.tk video')) return;
    muteAll();
    setInterval(muteAll, 250);
    ['play', 'volumechange', 'loadeddata'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (e.target && e.target.closest && e.target.closest('.tk')) muteAll();
      }, true);
    });
    $$('[data-tk-playpause]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = document.getElementById(btn.dataset.tkPlaypause);
        if (!v) return;
        v.muted = true; v.volume = 0;
        if (v.paused) { v.dataset.userPaused = 'false'; v.play(); btn.textContent = '❚❚'; btn.setAttribute('aria-label', 'Pristabdyti'); }
        else { v.dataset.userPaused = 'true'; v.pause(); btn.textContent = '▶'; btn.setAttribute('aria-label', 'Groti'); }
      });
    });
  }

  /* -------------------------------------------------- mobile sticky bar
     source: pastFold = #produktas bottom < 0 */
  /* A cookie notice, a chat bubble or any other app widget can sit across the
     foot of the screen. Showing the buy bar underneath one is worse than not
     showing it: the visitor sees nothing and the notice cannot be read either.
     The bar asks the browser what is actually painted where it would sit, and
     waits its turn. */
  function footIsClear(bar) {
    if (!bar || !document.elementFromPoint) return true;
    var prev = bar.getAttribute('data-show');
    bar.setAttribute('data-show', 'true');
    /* Look at the card itself, not the middle of the strip: the card sits in
       the right-hand corner and the strip around it lets clicks through, so a
       point in the middle answers with whatever is behind — which read as
       "covered" and kept the bar hidden for good. */
    var probe = bar.querySelector('.tk-sticky-pill') || bar;
    var r = probe.getBoundingClientRect();
    var clear = true;
    if (r.height > 0) {
      var x = Math.round(r.left + r.width / 2);
      var y = Math.round(r.top + r.height / 2);
      var hit = document.elementFromPoint(x, y);
      clear = !!(hit && bar.contains(hit));
    }
    if (prev !== 'true') bar.setAttribute('data-show', prev || 'false');
    return clear;
  }

  function bindSticky() {
    var buy = document.getElementById('produktas');
    var bars = $$('[data-tk-sticky]');
    if (!buy || !bars.length) return;
    function update() {
      var past = buy.getBoundingClientRect().bottom < 0;
      bars.forEach(function (b) {
        var show = past && footIsClear(b);
        b.setAttribute('data-show', show ? 'true' : 'false');
      });
      state.pastFold = past;
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
    /* A notice dismissed by the visitor leaves no event behind, so look again
       every now and then — cheaply, and only while the page is open. */
    setInterval(update, 1200);
  }

  /* --------------------------------------------------------------- cart */
  function notify(msg) {
    var t = $('[data-tk-toast]');
    if (!t) { console.warn('[TK]', msg); return; }
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(t._tkTimer);
    t._tkTimer = setTimeout(function () { t.hidden = true; }, 5000);
  }

  function addToCart(btn) {
    /* Take the last run of digits, so the admin URL
       (.../variants/45123456789012) and a gid:// both work as pasted. Without
       this a non-numeric value became Number(...) = NaN and left the cart with
       "id": null, which Shopify rejects for no visible reason. */
    var raw = (btn.dataset.variantId || '').trim();
    var digits = raw.match(/\d+/g);
    var id = digits ? digits[digits.length - 1] : '';
    if (raw && !id) {
      notify('Varianto ID neatpažintas: „' + raw + '". Įrašykite tik skaičių arba visą varianto nuorodą.');
      return;
    }
    if (!id) {
      /* A card that sells a product of its own is not wired through the size
         and bundle matrix at all, so naming a diameter and a bundle sent the
         shopkeeper looking in the wrong section entirely. Say which card it is
         and what it is missing. */
      if (btn.hasAttribute('data-own-variant')) {
        notify('Šiai kortelei nepasirinkta prekė. Redaktoriuje atidaryk sekciją ' +
               '„TK · Rinkinys" ir laukelyje „Product" pasirink rinkinį.');
        return;
      }
      /* Name the key the section is missing, so it can be pasted straight
         into the Shopify variant IDs setting without working it out. */
      notify('Krepšelis dar nesujungtas: ' + selVariant().label + ' · ' +
             (selBundle() ? selBundle().el.dataset.title : '') +
             '. Trūksta eilutės: ' + (btn.dataset.variantKey || '') + ' = varianto ID');
      return;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, data: d }; });
    }).then(function (res) {
      if (!res.ok) { notify(res.data.description || res.data.message || 'Nepavyko įdėti į krepšelį.'); return; }
      state.cart += 1;
      $$('[data-tk-cart-count]').forEach(function (e) { e.textContent = state.cart; e.hidden = false; });
      /* These two events are what a theme's or an app's cart listens for. We
         used to fire them AND open Dawn's own <cart-drawer> on top, which is
         how two carts appeared at once. What happens next is now a setting. */
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
      var after = btn.dataset.afterAdd || 'events';
      if (after === 'cart') { window.location.href = '/cart'; return; }
      if (after === 'drawer') {
        var drawer = document.querySelector('cart-drawer, #CartDrawer, .drawer--cart, #cart-drawer');
        if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
        window.location.href = '/cart';
      }
    }).catch(function () { notify('Nepavyko įdėti į krepšelį. Bandykite dar kartą.'); });
  }

  /* ------------------------------------------------------------- wiring */
  document.addEventListener('click', function (e) {
    var t = e.target;

    /* ------------------------------------------------ all-reviews catch-all
       Whatever rendered it — this build's button, an older section still in
       the theme, or a plain anchor — anything that means "show me all the
       reviews" belongs at the review app's widget, not at this page's own
       strip. Matching on the link target and on the wording covers every
       version without needing each section file to be current. */
    var allRev = t.closest && t.closest('a[href*="#atsiliepimai"], a[href*="#peiliai"], a[href*="#reviews"], [data-tk-all-reviews]');
    if (!allRev) {
      var near = t.closest && t.closest('button, a, [role="button"]');
      if (near && /visi\b[^]{0,20}atsiliepim/i.test((near.textContent || '').trim())) allRev = near;
    }
    if (allRev && !allRev.hasAttribute('data-tk-scroll-to')) {
      var rev = pickTarget(['#vitals-end-section', '.vtl-pr-main-widget']);
      if (rev.el) {
        if (e.preventDefault) e.preventDefault();
        goToTarget(rev.el);
        return;
      }
      var waitedR = 0;
      var pollR = setInterval(function () {
        waitedR += 120;
        var f = pickTarget(['#vitals-end-section', '.vtl-pr-main-widget']);
        if (f.el || waitedR >= 600) { clearInterval(pollR); if (f.el) goToTarget(f.el); }
      }, 120);
      if (e.preventDefault) e.preventDefault();
      return;
    }

    var size = t.closest && t.closest('[data-tk-size]');
    if (size) { selectSize(size.dataset.tkSize); return; }

    var bundle = t.closest && t.closest('[data-tk-bundle]');
    if (bundle) { selectBundle(bundle.dataset.tkBundle); return; }

    var shot = t.closest && t.closest('[data-tk-shot]');
    if (shot) { selectShot($$('[data-tk-shot]').indexOf(shot)); return; }

    var shotNav = t.closest && t.closest('[data-tk-shot-nav]');
    if (shotNav) {
      var ns = $$('[data-tk-shot]').length;
      if (ns) selectShot(state.shot + Number(shotNav.dataset.dir));
      return;
    }

    var acc = t.closest && t.closest('[data-tk-acc]');
    if (acc) { toggleAcc(acc); return; }

    var layer = t.closest && t.closest('[data-tk-layer]');
    if (layer) { selectLayer($$('[data-tk-layer]', layer.parentNode).indexOf(layer)); return; }

    var add = t.closest && t.closest('[data-tk-add]');
    if (add) { addToCart(add); return; }

    var burger = t.closest && t.closest('[data-tk-burger]');
    if (burger) {
      var menu = $('[data-tk-menu]');
      if (menu) {
        var open = menu.getAttribute('data-open') === 'true';
        menu.setAttribute('data-open', open ? 'false' : 'true');
        burger.setAttribute('aria-expanded', open ? 'false' : 'true');
      }
      return;
    }
    if (t.closest && t.closest('[data-tk-menu] a')) {
      var m = $('[data-tk-menu]');
      if (m) m.setAttribute('data-open', 'false');
      return;
    }

    /* source: scrollToReviews() — the widget's top minus the header */
    var goto_ = t.closest && t.closest('[data-tk-scroll-to]');
    if (goto_) {
      /* Several selectors may be listed: the first one present wins. That lets
         the button reach a review app's widget where it exists and fall back to
         this page's own section where it does not. */
      var want = (goto_.dataset.tkScrollTo || '').split(',');
      /* A review app builds its widget after the page is parsed, so the first
         selector can still be missing at the moment of the click — and the link
         would then settle for the fallback and land on this page's own strip
         instead. Give the preferred target a few frames to turn up before
         accepting a later one. */
      var found = pickTarget(want);
      if (found.el && found.idx === 0) { goToTarget(found.el); return; }
      var waited = 0;
      var poll = setInterval(function () {
        waited += 120;
        var f = pickTarget(want);
        if ((f.el && f.idx === 0) || waited >= 480) {
          clearInterval(poll);
          if (f.el) goToTarget(f.el);
          else if (found.el) goToTarget(found.el);
        }
      }, 120);
      return;
      /* Nothing to scroll to — fall through to the old expand, so the button
         still does something on a page without the review app. */
    }

    var more = t.closest && t.closest('[data-tk-more-reviews]');
    if (more) {
      state.allReviews = !state.allReviews;
      $$('.tk-rev-wrap').forEach(function (w) {
        w.setAttribute('data-all', state.allReviews ? 'true' : 'false');
      });
      more.textContent = state.allReviews ? 'Rodyti mažiau' : more.dataset.allLabel;
      return;
    }
  });

  /* The rating line is a link without an href, so give it the key
     handling a button would have had. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var g = e.target.closest && e.target.closest('[data-tk-scroll-to]');
    if (!g) return;
    e.preventDefault();
    g.click();
  });

  /* Size and bundle pills are radios: Enter and Space select, like a click. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target;
    if (t.closest && (t.closest('[data-tk-size]') || t.closest('[data-tk-bundle]'))) {
      e.preventDefault();
      t.click();
    }
  });

  /* Stamp the document so the horizontal lock applies without depending on
     :has(), which older Safari does not support. */
  function markPage() {
    if (document.querySelector('.tk')) document.documentElement.classList.add('tk-page');
  }


  /* Play only while the video is actually on screen. `autoplay` starts it the
     moment it loads, wherever it sits on a 10,000px page — that burns a
     visitor's data on footage they may never scroll to, and iOS often refuses
     to start it at all once it is far off-screen. Pausing when it leaves also
     stops it looping out of sight.

     A video the visitor paused by hand stays paused: the play/pause button sets
     data-user-paused, and this never overrides it. */
  /* ------------------------------------------------------------ video
     The clip plays only while it is on screen. Starting it is its own small
     problem: a browser may turn down play() because autoplay is blocked, or
     simply because not enough of the file has arrived yet, and those two look
     the same from here. Only the first deserves a play circle; the second just
     needs another try. */
  function fallbackFor(v) {
    var box = v.parentElement;
    return box ? box.querySelector('[data-tk-play-fallback]') : null;
  }

  function start(v, retried) {
    v.muted = true; v.volume = 0;
    var p = v.play();
    var fb = fallbackFor(v);
    if (!p || !p.then) return;
    p.then(function () { if (fb) fb.hidden = true; })
     .catch(function (err) {
       if (err && err.name === 'NotAllowedError') {
         if (fb) fb.hidden = false;
         return;
       }
       if (retried) { if (fb) fb.hidden = false; return; }
       /* Retry on whichever comes first: more data arriving, or a short wait.
          Waiting on 'canplay' alone deadlocks when the file was already ready
          — that event had fired long before and never fires again. */
       var again = function () {
         v.removeEventListener('canplay', again);
         clearTimeout(timer);
         if (v.dataset.userPaused !== 'true') start(v, true);
       };
       var timer = setTimeout(again, 600);
       v.addEventListener('canplay', again);
     });
  }

  function bindViewportVideo() {
    var vids = $$('.tk-tech-video-el');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) return;   // autoplay still applies
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.dataset.userPaused !== 'true') { start(v); }
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) {
      v.autoplay = false;          /* the observer owns playback from here */
      io.observe(v);
      var fb = fallbackFor(v);
      if (fb) {
        fb.addEventListener('click', function () {
          v.dataset.userPaused = 'false';
          start(v);
        });
      }
    });
  }

  /* ------------------------------------------ clear a floating header
     The store's header can be drawn over the top of this section, which buries
     the badge and the top of the gallery underneath it.

     Two earlier attempts measured the wrong thing. The first looked only for
     position:fixed — takumi.lt uses an absolutely positioned <sticky-header>.
     The second then demanded the header be pinned to the very top of the
     window, but it starts 43px down, below the announcement bar, so it was
     skipped again. Both were guesses about how a header is built.

     This asks the browser what is actually painted at this section's own top
     edge. Whatever answers, and however it is positioned, its bottom is where
     this section has to begin. Measured live on that store: 83px on desktop,
     75px on a phone — which is also why a typed-in number would have been
     wrong on one of them. */
  var headerMeasured = false;
  function clearFloatingHeader() {
    var el = $('.tk-buy-top');
    if (!el || el.getAttribute('data-auto-clear') === 'false') return;
    /* Only a measurement taken at the top of the page is trustworthy: further
       down, the header has either scrolled away or re-pinned itself, and the
       probe would read whatever content happens to be under it.
       Nothing is cleared before bailing out. An earlier version zeroed the
       offset first and then returned here, so every resize fired while the
       page was scrolled threw the offset away — which is why scrolling down
       and back up on a phone put the page under the header again, jumping as
       it went. The value is only ever replaced by a newer, valid one. */
    if ((window.pageYOffset || document.documentElement.scrollTop || 0) > 4) return;
    var r0 = el.getBoundingClientRect();
    if (r0.top < 0 || r0.top >= window.innerHeight) return;
    var x = Math.round(r0.left + Math.min(r0.width / 2, 200));
    var hit = document.elementFromPoint(x, Math.round(r0.top) + 2);
    var edge = r0.top + 2;
    var bottom = 0, node = hit;
    while (node && node !== document.body && node !== document.documentElement) {
      /* Skip anything wrapping this section: it is not covering us. */
      if (!node.contains(el)) {
        var cr = node.getBoundingClientRect();
        /* It has to straddle our top edge to be covering it. Without this the
           walk accepted any ancestor at all, and WebKit once answered 3723px
           from an element further down the page. */
        if (cr.height > 0 && cr.height <= 400 &&
            cr.top <= edge && cr.bottom > edge && cr.bottom > bottom) {
          bottom = cr.bottom;
        }
      }
      node = node.parentElement;
    }
    var overlap = Math.max(0, Math.round(bottom - r0.top));
    /* No header is taller than this; anything bigger is a misread. */
    if (overlap > 400) return;
    el.style.setProperty('--tk-top-auto', overlap + 'px');
    headerMeasured = true;
  }

  /* ------------------------------------------- blend the hex sections in
     A hex section is transparent and shows the page colour through it. Where a
     neighbour is a different shade the colour changes in one hard step, which
     is what reads as a line across the page — the pattern itself was already
     fading. Both neighbours are measured and their colour is carried into this
     section over the same distance the pattern fades. Matching neighbours get
     no gradient at all. */
  function opaqueBehind(el) {
    var n = el;
    while (n && n !== document.documentElement) {
      var bg = window.getComputedStyle(n).backgroundColor;
      if (bg && bg !== 'transparent' && bg.indexOf('rgba(0, 0, 0, 0)') !== 0) return bg;
      n = n.parentElement;
    }
    return 'rgb(11, 11, 12)';
  }
  function neighbourColour(host, dir) {
    var sib = dir < 0 ? host.previousElementSibling : host.nextElementSibling;
    while (sib) {
      var inner = sib.querySelector ? sib.querySelector('[data-screen-label]') : null;
      if (inner) return opaqueBehind(inner);
      sib = dir < 0 ? sib.previousElementSibling : sib.nextElementSibling;
    }
    return null;
  }
  function fade(colour) {
    var m = /rgba?\(\s*(\d+)[,\s]+(\d+)[,\s]+(\d+)/.exec(colour || '');
    return m ? 'rgba(' + m[1] + ',' + m[2] + ',' + m[3] + ',0)' : null;
  }
  function blendHexSections() {
    $$('.tk-hex').forEach(function (sec) {
      var host = sec.closest('[id^="shopify-section"]') || sec.parentElement;
      var own = opaqueBehind(sec);
      var px = (window.getComputedStyle(sec).getPropertyValue('--tk-hex-fade') || '140px').trim() || '140px';
      var stops = [];
      var top = neighbourColour(host, -1), bottom = neighbourColour(host, 1);
      if (top && top !== own && fade(top)) {
        stops.push(top + ' 0', fade(top) + ' ' + px);
      }
      if (bottom && bottom !== own && fade(bottom)) {
        stops.push(fade(bottom) + ' calc(100% - ' + px + ')', bottom + ' 100%');
      }
      if (!stops.length) { sec.style.removeProperty('--tk-hex-blend'); return; }
      sec.style.setProperty('--tk-hex-blend', 'linear-gradient(to bottom, ' + stops.join(', ') + ')');
    });
  }

  /* Shared by the scroll links: which of the listed selectors is on the page,
     and how to land on it. */
  function pickTarget(list) {
    for (var i = 0; i < list.length; i++) {
      var sel = (list[i] || '').trim();
      if (!sel) continue;
      var el = null;
      try { el = document.querySelector(sel); } catch (err) { el = null; }
      if (el) return { el: el, idx: i };
    }
    return { el: null, idx: -1 };
  }

  function goToTarget(target) {
    /* Stop short by however much the store's header covers, measured earlier,
       so the heading does not land underneath it. */
    var host = $('.tk-buy-top');
    var pad = host ? parseFloat(host.style.getPropertyValue('--tk-top-auto')) || 0 : 0;
    /* Lazy images between here and the target load while the page is moving,
       which pushes the target further down: a single computed destination
       lands around a thousand pixels short. Aim once, then nudge until the
       heading actually sits where it should. */
    window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - (pad + 16),
                      behavior: 'smooth' });
    (function settle(tries) {
      setTimeout(function () {
        var off = target.getBoundingClientRect().top - (pad + 16);
        if (Math.abs(off) <= 8 || tries > 6) return;
        window.scrollBy({ top: off, behavior: 'auto' });
        settle(tries + 1);
      }, tries ? 220 : 500);
    })(0);
  }

  function init() {
    markPage();
    blendHexSections();
    evenCardEdges();
    /* Web fonts land after first paint and change the wrapping, so measure
       again once they are in. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { evenCardEdges(); });
    }
    window.addEventListener('load', function () { setTimeout(evenCardEdges, 60); });
    selectShot(0, true);
    showSizeHero($('[data-tk-size][aria-checked="true"]'));
    bindGallerySwipe();
    dailySold();
    clearFloatingHeader();
    /* A phone's address bar sliding away fires resize on every scroll, with the
       width unchanged. Re-measuring then is pointless work and a source of
       visible jumps, so only a real width change re-runs it. */
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      headerMeasured = false;
      clearFloatingHeader();
      evenCardEdges();
    });
    window.addEventListener('orientationchange', function () {
      setTimeout(clearFloatingHeader, 250);
    });
    /* A header can settle late: web fonts change its height, or a script
       builds it after the page is parsed. A few spaced passes catch that and
       then stop. They are safe to repeat — each one either replaces the value
       with a newer valid measurement or leaves it alone. */
    [300, 1000, 2500].forEach(function (ms) { setTimeout(clearFloatingHeader, ms); });
    window.addEventListener('load', function () { setTimeout(clearFloatingHeader, 200); });

    /* Every pass above refuses to measure unless the page is at the top, which
       is correct — lower down the header has moved and the reading would be
       wrong. But a page can open already scrolled: the browser restoring a
       position, or a back navigation. Then no pass ever succeeded, the offset
       stayed at zero, and returning to the top showed the content tucked under
       the header again. This keeps watching until one measurement lands, and
       then stops listening. */
    var pending;
    function measureWhenAtTop() {
      if (headerMeasured) {
        window.removeEventListener('scroll', measureWhenAtTop);
        return;
      }
      if (pending) return;
      pending = requestAnimationFrame(function () {
        pending = 0;
        clearFloatingHeader();
        if (headerMeasured) window.removeEventListener('scroll', measureWhenAtTop);
      });
    }
    window.addEventListener('scroll', measureWhenAtTop, { passive: true });

    /* Coming back through the browser's history restores the page from cache
       without running any of the above again. */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { headerMeasured = false; clearFloatingHeader(); }
    });
    bindViewportVideo();
    renderPrice();
    bindCarousel('strip', 18);
    bindCarousel('rev', 14);
    bindCarousel('video', 10);
    bindExperience();
    bindHeroRev();
    bindVideo();
    bindSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  TK.state = state;
  TK.selectSize = selectSize;
  TK.selectBundle = selectBundle;
  TK.selectShot = selectShot;
  TK.fmt = fmt;
})();
